import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Alert, AlertDescription } from '@/components/ui/alert';

export function NewJobPage() {
  const [file, setFile] = useState<File | null>(null);
  const [entry, setEntry] = useState('src/server.ts');
  const [preCommand, setPreCommand] = useState('npm install');
  const [release, setRelease] = useState(true);

  return (
    <div className="max-w-3xl space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Submit a new job</h1>
        <p className="text-muted-foreground text-sm">Upload a tarball or zip to compile.</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Upload source</CardTitle>
          <CardDescription>
            Accepts <code>.zip</code> or <code>.tar.gz</code>. Your code is deleted immediately
            after compilation.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="archive">Source archive</Label>
            <Input
              id="archive"
              type="file"
              accept=".zip,.tar,.tar.gz,.tgz"
              onChange={(e) => setFile(e.target.files?.[0] ?? null)}
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="entry">Entry point</Label>
            <Input id="entry" value={entry} onChange={(e) => setEntry(e.target.value)} />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="pre">Pre-command (optional)</Label>
            <Input id="pre" value={preCommand} onChange={(e) => setPreCommand(e.target.value)} />
          </div>
          <div className="flex items-center gap-2">
            <input
              id="release"
              type="checkbox"
              checked={release}
              onChange={(e) => setRelease(e.target.checked)}
            />
            <Label htmlFor="release">Release mode</Label>
          </div>
          <Alert>
            <AlertDescription>
              Direct job submission from the dashboard will be available when the{' '}
              <code>api</code> service is deployed. For now, use the{' '}
              <code>pure compile</code> CLI to submit jobs.
            </AlertDescription>
          </Alert>
          <div className="flex justify-end">
            <Button disabled={!file}>Submit job</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
